
const emojis = [
    // Smiles and Emotions
    { id: 1, emoji: "😀" },
    { id: 2, emoji: "😃" },
    { id: 3, emoji: "😄" },
    { id: 4, emoji: "😁" },
    { id: 5, emoji: "😆" },
    { id: 6, emoji: "😂" },
    { id: 7, emoji: "🤣" },
    { id: 8, emoji: "😊" },
    { id: 9, emoji: "😇" },
    { id: 10, emoji: "🙂" },
    { id: 11, emoji: "🙃" },
    { id: 12, emoji: "😉" },
    { id: 13, emoji: "😌" },
    { id: 14, emoji: "😍" },
    { id: 15, emoji: "😘" },
    { id: 16, emoji: "😗" },
    { id: 17, emoji: "😙" },
    { id: 18, emoji: "😚" },
    { id: 19, emoji: "😋" },
    { id: 20, emoji: "😜" },
    { id: 21, emoji: "😝" },
    { id: 22, emoji: "😛" },
    { id: 23, emoji: "🤗" },
    { id: 24, emoji: "🤩" },
    { id: 25, emoji: "🤔" },
    { id: 26, emoji: "🤨" },
    { id: 27, emoji: "😐" },
    { id: 28, emoji: "😑" },
    { id: 29, emoji: "😶" },
    { id: 30, emoji: "😏" },
    { id: 31, emoji: "😒" },
    { id: 32, emoji: "🙁" },
    { id: 33, emoji: "😞" },
    { id: 34, emoji: "😔" },
    { id: 35, emoji: "😟" },
    { id: 36, emoji: "😕" },
    { id: 37, emoji: "🙃" },
    { id: 38, emoji: "🤑" },
    { id: 39, emoji: "😲" },
    { id: 40, emoji: "😳" },
    { id: 41, emoji: "😱" },
    { id: 42, emoji: "😨" },
    { id: 43, emoji: "😰" },
    { id: 44, emoji: "😥" },
    { id: 45, emoji: "😓" },
    { id: 46, emoji: "🤯" },
    { id: 47, emoji: "😩" },
    { id: 48, emoji: "😫" },
    { id: 49, emoji: "😵" },
    { id: 50, emoji: "😵‍💫" },
    { id: 51, emoji: "🤪" },
    { id: 52, emoji: "😷" },
    { id: 53, emoji: "🤒" },
    { id: 54, emoji: "🤕" },
    { id: 55, emoji: "🤢" },
    { id: 56, emoji: "🤮" },
    { id: 57, emoji: "🥴" },
    { id: 58, emoji: "😈" },
    { id: 59, emoji: "👿" },
    { id: 60, emoji: "💀" },
    { id: 61, emoji: "☠️" },
    { id: 62, emoji: "👻" },

     // Body Emojis
     { id: 101, emoji: "👋" },
     { id: 102, emoji: "🤚" },
     { id: 103, emoji: "🖐️" },
     { id: 104, emoji: "✋" },
     { id: 105, emoji: "🖖" },
     { id: 106, emoji: "👈" },
     { id: 107, emoji: "👉" },
     { id: 108, emoji: "👆" },
     { id: 109, emoji: "👐" },
     { id: 110, emoji: "🤲" },
     { id: 111, emoji: "🙌" },
     { id: 112, emoji: "🙏" },
     { id: 113, emoji: "💪" },
     { id: 114, emoji: "🤳" },
     { id: 115, emoji: "👂" },
     { id: 116, emoji: "👃" },
     { id: 117, emoji: "🦷" },
     { id: 118, emoji: "🦴" },
     { id: 119, emoji: "👀" },
     { id: 120, emoji: "👅" },
     { id: 121, emoji: "👋" },
     { id: 122, emoji: "🦶" },
     { id: 123, emoji: "🦵" },
     { id: 124, emoji: "🦷" },
     { id: 125, emoji: "💋" },
     { id: 126, emoji: "🩸" },
     { id: 127, emoji: "🩹" },
     { id: 128, emoji: "🦾" },
     { id: 129, emoji: "🦿" },
     { id: 130, emoji: "🦼" },
     { id: 131, emoji: "🦽" },
    
    // Gender Emojis
    { id: 63, emoji: "👶" },
    { id: 64, emoji: "👦" },
    { id: 65, emoji: "👧" },
    { id: 66, emoji: "🧒" },
    { id: 67, emoji: "👨" },
    { id: 68, emoji: "👩" },
    { id: 69, emoji: "🧑" },
    { id: 70, emoji: "👵" },
    { id: 71, emoji: "👴" },
    { id: 72, emoji: "👲" },
    { id: 73, emoji: "👳" },
    { id: 74, emoji: "🧕" },
    { id: 75, emoji: "👮" },
    { id: 76, emoji: "🕵️‍♂️" },
    { id: 77, emoji: "🕵️‍♀️" },
    { id: 78, emoji: "👩‍⚕️" },
    { id: 79, emoji: "👨‍⚕️" },
    { id: 80, emoji: "👩‍🎓" },
    { id: 81, emoji: "👨‍🎓" },
    { id: 82, emoji: "👩‍🏫" },
    { id: 83, emoji: "👨‍🏫" },
    { id: 84, emoji: "👩‍🌾" },
    { id: 85, emoji: "👨‍🌾" },
    { id: 86, emoji: "👩‍🍳" },
    { id: 87, emoji: "👨‍🍳" },
    { id: 88, emoji: "👩‍🔧" },
    { id: 89, emoji: "👨‍🔧" },
    { id: 90, emoji: "👩‍🏭" },
    { id: 91, emoji: "👨‍🏭" },
    { id: 92, emoji: "👩‍💻" },
    { id: 93, emoji: "👨‍💻" },
    { id: 94, emoji: "👩‍🎤" },
    { id: 95, emoji: "👨‍🎤" },
    { id: 96, emoji: "👩‍🚀" },
    { id: 97, emoji: "👨‍🚀" },
    { id: 98, emoji: "👩‍⚖️" },
    { id: 99, emoji: "👨‍⚖️" },
    { id: 100, emoji: "🧑‍⚖️" },

    // Add more emojis as needed
];

export default emojis;
